import ContractPart from './active_record/contract_part'
import utils from '@eitje/utils'

class Salary extends ContractPart {
	static tableName = 'salaries'
	static sort = {field: 'start_date', direction: 'desc'}

	constructor(props) {
		super(props)
		this.amount = Number(this.amount)
	}

	formattedSalary() {
		return utils.formatMoney(this.amount)
	}
}

export default Salary
